// extracted by mini-css-extract-plugin
export default {"button":"Button_button__1mpjR","deleteButton":"Button_deleteButton__Stfq6"};